export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Votre décision"])},
        "decided": {
          "approve": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dossier approuvé"])},
          "refuse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dossier refusé, motif envoyé au client"])},
          "complement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Demande de compléments envoyée au client"])}
        },
        "continue_to_handling": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choisir le type de prise en charge"])},
        "close": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermer"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your decision"])},
        "decided": {
          "approve": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Claim approved"])},
          "refuse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Claim refused, reason sent to the customer"])},
          "complement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Request for more information sent to the customer"])}
        },
        "continue_to_handling": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choose the handling type"])},
        "close": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close"])}
      }
    }
  })
}
